import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const budibase = defineConnector({
  identifier: "budibase",
  name: "Budibase",
  tagLine: "Low-code application platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://.*.budibase.app/.*",
  auth: (app) =>
    headerAuth([{ name: "x-budibase-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Budibase instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "your-instance.budibase.app",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Budibase, click your avatar and select **API key** to generate one. See the [API docs](https://docs.budibase.com/docs/public-api) for details.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/public/v1/applications`,
  },
});
